<template>
  <div>
    <CollectionList class="m-b-10"></CollectionList>
    <FileCenter class="m-b-10 min-height-300">
      <h3 class="m-v-0" slot="title">部门文件共享</h3>
    </FileCenter>
  </div>
</template>

<script>
import CollectionList from 'components/collection/CollectionList.vue'
import FileCenter from 'components/file/FileCenter.vue'

export default {
  components: {CollectionList, FileCenter},
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/home/Dashboard.vue